import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES, type RoutePath } from './routes.config';

export const useAppNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateTo = (path: RoutePath, options?: { replace?: boolean; state?: any }) => {
    navigate(path, options);
  };

  const goBack = () => {
    navigate(-1);
  };

  const goForward = () => {
    navigate(1);
  };

  const isCurrentRoute = (path: RoutePath): boolean => {
    return location.pathname === path;
  };

  const redirectToLogin = (returnUrl?: string) => {
    navigate(ROUTES.LOGIN, { 
      state: { from: returnUrl || location.pathname },
      replace: true 
    });
  };

  const redirectAfterLogin = () => {
    const returnUrl = location.state?.from || ROUTES.HOME;
    navigate(returnUrl, { replace: true });
  };

  return {
    navigateTo,
    goBack,
    goForward,
    isCurrentRoute,
    redirectToLogin,
    redirectAfterLogin,
    currentPath: location.pathname,
    currentRoute: location,
    ROUTES, // Export routes for convenience
  };
};